export default __webpack_public_path__ + "static/media/background-7.fe842372.jpg";